import { createContext } from 'react';
import { Sidebar } from 'types/uiTypes';

interface ContextState {
    isExperiment: boolean;
    uiText: Sidebar;
    finnkode: string;
    isOwnAd: string;
}

const SidebarContext = createContext({} as ContextState);

export default SidebarContext;
